import { ReactComponent as Bulldozer } from 'assets/bulldozer.svg'
import { selectMapOptions } from '../Maps/Map/mapSlice'
import { getDistance } from '../Maps/Map/mapUtils'
import useTranslation from 'hooks/useTranslation'
import { selectPlaceData } from './placeSlice'
import Skeleton from 'react-loading-skeleton'
import MmRating from 'components/MmRating'
import { useSelector } from 'react-redux'

const DetailsLocation = ({ succeed }) => {
  const { street, estateNumber, mm_score, localNumber, city, constructionDate, gpslatitude, gpslongitude } = useSelector(selectPlaceData)
  const { position } = useSelector(selectMapOptions)

  const { t } = useTranslation('mapDetails')

  return (
    <div className='details__location'>
      <div className='location__main'>
        {succeed ? <>
          <div className='location__title --secFont'>{city}, {t('st')}{street} {estateNumber}{localNumber ? `/${localNumber}` : ''}</div>
          {constructionDate
            ? <div className='location__construction'>
              <div className='location__construction__top center'>
                <Bulldozer />
                <div>{t('theYardIsUnderConstruction')}</div>
              </div>
              <div className='location__construction__bottom'>{t('availableFrom')} {constructionDate}</div>
            </div>
            : typeof mm_score === 'number'
              ? <div className='location__address center'>
                <MmRating number={mm_score} />
              </div>
              : null}
          {(position && succeed) && <div className='location__distance'>
            {constructionDate ? 'W budowie, ' : ''}{getDistance(position, [gpslatitude || 51.666, gpslongitude || 19.389]).toFixed(1)}km {t('fromYou')}
          </div>}
        </> : <Skeleton
          count={1}
          containerClassName='skeleton__desc'
          style={{
            '--skeleton-base': '#353535',
            '--skeleton-highlight': '#393939'
          }} />}
      </div>
    </div>
  )
}

export default DetailsLocation